export default function () {
  return {
    token: null,
    user: null,
  };
}
